import { getApiUrl } from '../config/api';

export const generatePropertyDescription = async (propertyData) => {
  const token = localStorage.getItem('token');
  const response = await fetch(getApiUrl('/api/properties/generate-description'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(propertyData),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok || !data.success) {
    throw new Error(data.message || 'Failed to generate description.');
  }

  return data;
};
